import { ComponentType } from 'src/types/SCADA/componentsTypes';
import { Valve } from 'src/components/SCADA/assetComponents/valve/Valve';
import { Well } from 'src/components/SCADA/assetComponents/well';
import { Tower } from 'src/components/SCADA/assetComponents/tower';
import { withMemo } from 'src/HOC/withMemo';
import { PumpSCADA } from 'src/components/SCADA/generalComponents/pumpSCADA';
import { TextLabel } from 'src/components/SCADA/generalComponents/textLabel';
import { LiveTagLabel } from 'src/components/SCADA/generalComponents/LiveTagLabel';
import { Rectangle } from 'src/components/SCADA/generalComponents/rectangle';
import { ImageUpload } from 'src/components/SCADA/generalComponents/imapeUpload/ImageUpload';
import { WaterLevelElement } from 'src/components/SCADA/assetComponents/waterLevelElement/WaterLevelElement';

export const componentMap: Record<ComponentType, React.ComponentType<any>> = {
  [ComponentType.Pump]: withMemo((props) => (
    <PumpSCADA type={ComponentType.Pump} {...props} width={props.width} height={props.height} />
  )),
  [ComponentType.SubmersiblePump]: withMemo((props) => (
    <PumpSCADA
      type={ComponentType.SubmersiblePump}
      {...props}
      width={props.width}
      height={props.height}
    />
  )),
  [ComponentType.SpinningPump]: withMemo((props) => (
    <PumpSCADA
      type={ComponentType.SpinningPump}
      {...props}
      width={props.width}
      height={props.height}
    />
  )),
  [ComponentType.Well]: withMemo(Well),
  [ComponentType.Tower]: withMemo(Tower),
  [ComponentType.Valve]: withMemo(Valve),
  [ComponentType.TextLabel]: withMemo((props) => (
    <TextLabel {...props} width={props.width} height={props.height} />
  )),

  [ComponentType.LiveTagLabel]: withMemo((props) => (
    <LiveTagLabel {...props} width={props.width} height={props.height} />
  )),
  [ComponentType.ImageUpload]: withMemo((props) => (
    <ImageUpload {...props} width={props.width} height={props.height} />
  )),
  [ComponentType.Rectangle]: withMemo(Rectangle),
  [ComponentType.WaterLevelShape]: withMemo(WaterLevelElement),
  [ComponentType.Rotor]: withMemo((props) => <PumpSCADA type={ComponentType.Rotor} {...props} />),
};
